module.exports = __webpack_public_path__ + "img/header_logo_comscore.a23766ae.png";